var gallryThumbs = new Swiper('.product_thumbnail_slider' , {
  slidesPerView: 4,
  spaceBetween : 10,
  watchOverflow: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  direction: 'horizontal' ,
  breakpoints: {
    1068: {            
      direction: 'vertical',
    }
  }
})

var gallryMain = new Swiper('.product_main_slider' ,{
  spaceBetween : 10,
  sliderPerView:1,
  watchOverflow: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  thumbs:{
   swiper: gallryThumbs
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  }  
})
